<div class="form-card">
    <div class="form-details">
      <div class="pdf-icon">
        <img src="../../../../../../assets/images/actionIcon.png" alt="">
      </div>
      <div class="form-content">
        <div class="form-name">{{actionName}}</div>
        <div class="form-description">{{actionDesc}}</div>
      </div>

    </div>
    <div class="action-icons">
      <div class="button" (click)="emitClick($event)">{{actionButtonText}}</div>
    </div>
  </div>